import React, { useContext, useState } from "react"
import { CalendarEventContext } from "./CalendarEventContext"
import CalendarHovercard from "./CalendarHovercard"

function CalendarWeekday({ dayofmonth, datearr }) {
  const { events } = useContext(CalendarEventContext)
  const [showHovercard, setShowHovercard] = useState(false)

  let filteredEvents = events.filter(e => datesAreEqual(e.date, datearr))

  if (filteredEvents.length > 0) {
    return (
      <div className="ncal-cell ncal-cell__day"
        onMouseEnter={() => setShowHovercard(true)}
        onMouseLeave={() => setShowHovercard(false)}
      >
      <span className="ncal-cell__day--eventday">{datearr[2]}</span>
        {showHovercard ? <CalendarHovercard events={filteredEvents}/> : undefined}
      </div>
    )
  }
  else {
    return (
      <div className="ncal-cell ncal-cell__day">
        {datearr[2]}
      </div>
    )
  }


}

function datesAreEqual(datearr1, datearr2) {
  if (datearr1 === undefined || datearr2 === undefined) return false
  return datearr1[0] === datearr2[0] && datearr1[1] === datearr2[1] && datearr1[2] === datearr2[2]
}

export default CalendarWeekday